<!-- This templates insert a chunck if the var is defined -->
<template>
  <span v-if="this.condition()">

  <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">

        <v-chip
             class="ma-2"
             :color=data.color
             text-color="black"
             v-bind="attrs"
             v-on="on"
             v-on:click="scrollMeTo(data.id)"
         >
          <v-avatar left>
            <v-icon> {{ data.icon }}</v-icon>
          </v-avatar>
          {{ data.text }}
        </v-chip>

          </template>
     <span>{{ data.tooltip }} </span>
          </v-tooltip>

  </span>
</template>

<script>
export default {
  name: "SimpleItem",
  props: {
    data: {},
    showifempty: {default: false},
    link: {}
  },
  methods: {
    condition() {
      return this.data != null && (this.showifempty || this.data.text != "" || this.data.icon != "");
    },



  },
};
</script>
